module.exports = __webpack_public_path__ + "static/img/banner-mobile22.70f9860.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-mobile22.jpg
// module id = Jq0c
// module chunks = 1